import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Separator } from '../ui/separator';
import { Slider } from '../ui/slider';
import { Layers } from 'lucide-react';

export const PropertiesPanel = ({ active, updateProp, fc, rerender }) => {
  if (!active) return null;

  return (
    <div className="w-52 border-l bg-background p-3 overflow-y-auto shrink-0 space-y-3" data-testid="properties-panel">
      <div className="flex items-center gap-1.5">
        <Layers className="w-3.5 h-3.5 text-muted-foreground" />
        <h3 className="font-semibold text-[10px] uppercase tracking-wider text-muted-foreground">Position & Size</h3>
      </div>
      <Separator />

      <div className="grid grid-cols-2 gap-1.5">
        <div>
          <Label className="text-[10px]">X</Label>
          <Input type="number" value={Math.round(active.left || 0)}
            onChange={(e) => updateProp('left', parseInt(e.target.value) || 0)} className="h-7 text-xs" data-testid="prop-x" />
        </div>
        <div>
          <Label className="text-[10px]">Y</Label>
          <Input type="number" value={Math.round(active.top || 0)}
            onChange={(e) => updateProp('top', parseInt(e.target.value) || 0)} className="h-7 text-xs" data-testid="prop-y" />
        </div>
      </div>

      {active.width != null && (
        <div className="grid grid-cols-2 gap-1.5">
          <div>
            <Label className="text-[10px]">W</Label>
            <Input type="number" value={Math.round(active.getScaledWidth?.() || active.width || 0)}
              onChange={(e) => {
                const v = parseInt(e.target.value) || 1;
                active.set({ scaleX: v / (active.width || 1) });
                active.setCoords();
                fc.current.renderAll();
                rerender();
              }}
              className="h-7 text-xs" data-testid="prop-w" />
          </div>
          <div>
            <Label className="text-[10px]">H</Label>
            <Input type="number" value={Math.round(active.getScaledHeight?.() || active.height || 0)}
              onChange={(e) => {
                const v = parseInt(e.target.value) || 1;
                active.set({ scaleY: v / (active.height || 1) });
                active.setCoords();
                fc.current.renderAll();
                rerender();
              }}
              className="h-7 text-xs" data-testid="prop-h" />
          </div>
        </div>
      )}

      <div className="space-y-1">
        <Label className="text-[10px]">Rotation: {Math.round(active.angle || 0)}deg</Label>
        <Slider value={[Math.round(active.angle || 0)]}
          onValueChange={([v]) => updateProp('angle', v)} min={0} max={360} step={1} data-testid="prop-rotation" />
      </div>

      <div className="space-y-1">
        <Label className="text-[10px]">Opacity: {Math.round((active.opacity ?? 1) * 100)}%</Label>
        <Slider value={[Math.round((active.opacity ?? 1) * 100)]}
          onValueChange={([v]) => updateProp('opacity', v / 100)} min={0} max={100} step={1} data-testid="prop-opacity" />
      </div>

      <div className="flex gap-1">
        <Button variant="outline" size="sm" className="flex-1 text-[10px] h-7"
          onClick={() => updateProp('flipX', !active.flipX)} data-testid="prop-flip-h">Flip H</Button>
        <Button variant="outline" size="sm" className="flex-1 text-[10px] h-7"
          onClick={() => updateProp('flipY', !active.flipY)} data-testid="prop-flip-v">Flip V</Button>
      </div>
    </div>
  );
};
